export const VISUAL_RECOGNITION_FEATURE = 'visualRecognition';
